import {Injectable} from '@angular/core';

const TRACKER_KEY: string = 'tracker';
const COOKIE_LIFE_TIME: number = 86400 * 7; // 7 days

export interface TrackerData {
  trackerId?: string;
  trackerIdParams?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TrackerService {
  // DO NOT STORE DEFAULT TRACKER
  private defaultTracker: TrackerData = {
    trackerId: undefined,
    trackerIdParams: undefined,
  };

  constructor() {
  }

  getDefaultTrackerData(): TrackerData {
    return this.defaultTracker;
  }

  getCurrentTrackerData(fallback?: TrackerData): TrackerData | null {
    const rawData = localStorage.getItem(TRACKER_KEY);
    if (!rawData) {
      return fallback || null;
    }
    const trackerData = JSON.parse(rawData);
    if (this.isExpired(trackerData.expireAt)) {
      return fallback || null;
    }
    return trackerData.data;
  }

  persistTrackerData(trackerData: TrackerData, force: boolean = false): boolean {
    const expireAt = new Date(Date.now() + COOKIE_LIFE_TIME * 1000);
    const currentTrackerData = this.getCurrentTrackerData();
    if (force || !currentTrackerData) {
      localStorage.setItem(TRACKER_KEY, JSON.stringify({data: trackerData, expireAt}));
      return true;
    }
    return false;
  }

  parseTrackerDataFromRelativeUrl(url: string): TrackerData | null {
    const urlObject = new URL(url, 'http://dummy');
    return this.parseTrackerDataFromUrl(urlObject);
  }

  parseTrackerDataFromAbsoluteUrl(url: string): TrackerData | null {
    const urlObject = new URL(url);
    return this.parseTrackerDataFromUrl(urlObject);
  }

  urlFormat(trackerData: TrackerData) {
    const obj: {[key: string]: string} = {};
    if (trackerData.trackerId) {
      obj['tracker_id'] = trackerData.trackerId;
    }
    if (trackerData.trackerIdParams) {
      obj['tracker_id_params'] = trackerData.trackerIdParams;
    }
    return obj;
  }

  private isExpired(date: Date): boolean {
    return date < new Date();
  }

  private parseTrackerDataFromUrl(url: URL): TrackerData | null {
    const searchParams = url.searchParams;
    if (searchParams.get('tracker_id') === null) {
      return null;
    }
    const trackerData: TrackerData = {
      trackerId: searchParams.get('tracker_id') as string
    };
    if (searchParams.get('tracker_id_params') !== null) {
      trackerData.trackerIdParams = searchParams.get('tracker_id_params') as string;
    }
    return trackerData;
  }
}
